import React from 'react';

export default function VesselList() {
  return <div>List</div>;
}
